
import {ISelectValues} from "../../../component/ISelectValues";

export const ID_FILTER_SEARCH = 'search';
export const ID_FILTER_CUSTOMER_FIRST_NAME = 'first-name';
export const ID_FILTER_CUSTOMER_LAST_NAME = 'last-name';
export const ID_FILTER_CUSTOMER_ID = 'customer-id';
export const ID_FILTER_CUSTOMER_COMPANY_NAME = "customer-company-name"
export const ID_FILTER_INVOICETYPE = 'type';
export const ID_FILTER_LEGAL_ENTITIES = 'legal-entities';
export const ID_FILTER_DEALERS = 'dealers'
export const ID_FILTER_INVOICEDATEFROM = 'invoice-date-from';
export const ID_FILTER_INVOICEDATETO = "invoice-date-to";
export const ID_FILTER_STATUS = "statuses";
export const ID_FILTER_INVOICE_NUMBER = "invoice-number";
export const ID_FILTER_SAP_INVOICE_NUMBER = "sap-invoice-number";
export const ID_FILTER_PARENT_SAP_INVOICE_NUMBER = "parent-sap-invoice-number";
export const ID_FILTER_RA_CODE = "ra-code";
export const ID_FILTER_CORRELATION_NAME = "correlationName";
export const ID_FILTER_CORRELATION_ID = "correlationId";

export const ID_FILTER_DUE_DATE_FROM = 'dueDateFrom';
export const ID_FILTER_DUE_DATE_TO = "dueDateTo";
export const ID_FILTER_CREATION_DATE_FROM = "creationDateFrom";
export const ID_FILTER_CREATION_DATE_TO = "creationDateTo";
export const ID_FILTER_PAYMENT_METHOD = "paymentMethod";
export const ID_FILTER_TERMS_OF_PAYMENT = "termsOfPayment";
export const ID_FILTER_AMOUNT_FROM = "amountFrom";
export const ID_FILTER_AMOUNT_TO = "amountTo";


export const invoiceDefaultValues = {
    operator: "",
    customerId: "",
    customerFirstName: "",
    customerLastName: "",
    customerCompanyName: "",
    invoiceType: [],
    statuses: [],
    invoiceDateFrom: null,
    invoiceDateTo: null,
    sapInvoiceNumber: "",
    parentSapInvoiceNumber: "",
    invoiceNumber: "",
    correlationName: "",
    correlationId: "",
    dueDateFrom: null,
    dueDateTo: null,
    creationDateFrom: null,
    creationDateTo: null,
    paymentMethod: [],
    termsOfPayment: "",
    amountFrom: "",
    amountTo: "",
    dealers: []   
};
